import { InferRequestType, InferResponseType } from "hono";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import toast from "@/lib/toast";
import { t } from "@/lib/localization";

export type CreatePhotoAvatarRequest = InferRequestType<
    (typeof client.api.avatars.heygen.avatars.photo)["$post"]
>["json"];
export type CreatePhotoAvatarResponse = InferResponseType<
    (typeof client.api.avatars.heygen.avatars.photo)["$post"],
    200
>;

export const useCreatePhotoAvatar = () => {
    const qc = useQueryClient();
    return useMutation<CreatePhotoAvatarResponse, Error, CreatePhotoAvatarRequest>(
        {
            mutationKey: ["createPhotoAvatar"],
            mutationFn: async (json) => {
                const response = await client.api.avatars.heygen.avatars.photo.$post({ json });
                if (!response.ok) throw new Error("Failed to create avatar");
                return await response.json();
            },
            onSuccess: () => {
                toast.success(t("avatars.toast.create-photo.success"), {
                    keyName: "avatars.toast.create-photo.success",
                });
                qc.invalidateQueries({ queryKey: ["avatars"] });
            },
            onError: () => {
                toast.error(t("avatars.toast.create-photo.error"), {
                    keyName: "avatars.toast.create-photo.error",
                });
            },
        }
    );
};
